import { SortableColumn } from './sortable-column';
import { TableHeader as _TableHeader } from './table-header';
import { TableHeaderColumn } from './table-header.column';

/**
 * Compound component for table headers. Provides Column and SortableColumn sub-components
 * for building accessible, sortable table headers.
 */
const TableHeader = Object.assign(_TableHeader, {
  Column: TableHeaderColumn,
  SortableColumn,
});

export { TableHeader };
